import { twMerge } from 'tailwind-merge';

const TextField = ({ className, ...properties }) => {
    return <input className={twMerge('text-deep-black px-4 h-14 w-full bg-pure-white border rounded-lg border-grey-200 focus:border-primary-500 bg-pure-white focus:outline-none', className)} {...properties} />;
};

export default TextField;
